import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const usersAtom = atom<any>({
    key: RecoilKeys.Users,
    default: [],
  });